export default "__VITE_ASSET__BotVWOno__"